import { render, staticRenderFns } from "./scrollNotice.vue?vue&type=template&id=639de1eb&scoped=true"
import script from "./scrollNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./scrollNotice.vue?vue&type=script&setup=true&lang=js"
import style0 from "./scrollNotice.vue?vue&type=style&index=0&id=639de1eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639de1eb",
  null
  
)

export default component.exports